import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Paper, Stack, Typography } from "@mui/material";
import MailCheckForm from "./MailCheckForm";
import PasswordCheckForm from "./PasswordCheckForm";
import bgImage from "static/bgImage.png";
import ellipse from "static/bgEllipse.png";
import authService from "services/authService";
import { useNavigate } from "react-router-dom";
import { accountUpdated, login } from "redux/slices/accountSlice";
import { useDispatch } from "react-redux";
import { signInWithRedirect, signOut } from "aws-amplify/auth";
import { ReactComponent as Logoets } from "static/svgs/logoets.svg";
import { ReactComponent as NotiIcon } from "static/svgs/NotiIcon.svg";
import { ReactComponent as Logoets1 } from "static/svgs/ets-logo1.svg";
import { ReactComponent as Logoets2 } from "static/svgs/ets-logo2.svg";
// import { useCookies } from "react-cookie";
// import assessmentService from "services/assessmentService";

const SffLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState<string>("");

  const [errorMessage, setErrorMessage] = useState<string>("");
  // const [cookies, setCookie] = useCookies(["authToken"]);

  const handleLogin = async (password: string) => {
    const data = {
      email: email,
      password: password,
    };

    try {
      setErrorMessage("");
      await authService.login(data);

      // const cookie: any = {
      //   httpOnly: false,
      //   maxAge: 86400 * 1000,
      //   domain: "ets.org",
      //   path: "/",
      //   sameSite: "None",
      //   secure: true,
      // };

      // let token = resp.access || resp.accessToken?.jwtToken;
      // console.log('Token=', token, cookies);
      // authService.setAuthToken(token);
      // setCookie('authToken', token, cookie);

      const account = await authService.loadAccount();
      dispatch(login(account));
      dispatch(accountUpdated(account));
      navigate("/");
    } catch (e) {
      console.log("Error=", e);
      setErrorMessage(
        `Incorrect password or email. Please, check your credentials`
      );
    }
  };

  const handleLoginWithAWS = async () => {
    try {
      await signInWithRedirect({ provider: { custom: 'Okta' } });
    } catch (e) {
      console.log('Error', e);
      await signOut();
      await signInWithRedirect({ provider: { custom: 'Okta' } });
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  // useEffect(() => {
  //   if(email==null){
  //   document.body.style.backgroundColor = 'rgba(193, 198, 200, 1)';
  //   // document.body.style.backdropFilter = 'blur(5px)'; // Blur the background
  //   document.body.style.zIndex = '3'
    
  //   setIsModalOpen(true);
  //   }
  // }, []); // Empty dependency array ensures this runs once after the initial render

  // const closeModal = () => {
  //   setIsModalOpen(false); // Close the modal
  // };
  return (
    <>
     <Dialog
        open={isModalOpen}
        // onClose={closeModal} // Optional: Close modal when clicking outside
        maxWidth='md'
        PaperProps={{
          sx: {
            padding: '0px',
            borderRadius: '10px',
            marginBottom: '30%', 
            width:'757px',
            transform: 'translateY(-30%)', 
            zIndex: 9999, 
            display: 'flex', 
            position: 'relative', 
            
          },
        }}
      >
        {/* Vertical Bar */}
        <Box
             sx={{
              width: '8px', 
              backgroundColor: 'rgba(189, 147, 241, 1)', 
              borderRadius: '6px 0 0 6px', 
              position: 'absolute', 
              top: 0,
              left: 0,
              bottom: 0, 
            }}
        />
        
        {/* Icon placed vertically in the middle of the modal */}
        <Box
          sx={{
            position: 'absolute',
            left: '15px', 
            top: '50%', 
            transform: 'translateY(-50%)', 
            zIndex: 10000, 
          }}
        >
          <IconButton>
          <NotiIcon />
          </IconButton>
        </Box>
        
        {/* Modal Content */}
        <DialogContent
          sx={{
            paddingLeft: '100px', 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            paddingY:'20px',
            
            
          }}
        >
          <DialogTitle sx={{fontSize:'18px', fontWeight:'600',padding:'0px'}}>Important Notice</DialogTitle>
          <Box>
            <p style={{color:'rgba(69, 84, 89, 1)', fontSize:'16px', fontWeight:'400', fontFamily:'Open Sans', marginTop:'5px', marginBottom:'0px'}}>Please be advised that our site will be temporarily unavailable due to ongoing development updates. We anticipate this disruption to be brief. We apologize for any inconvenience this may cause.</p>
          </Box>
        </DialogContent>
      </Dialog>
      <Stack
        direction="row"
        alignItems="center"
        gap={15}
        sx={{ height: "100%", paddingLeft: 14 }}
      >
        <Typography fontSize={77} width={370}>
          Skills for the Future
        </Typography>
        <Stack
          direction="column"
          sx={{ justifyContent: "center", height: "100%" }}
        >
          <Box width="560px" sx={{ position: "relative", alignSelf: "center" }}>
            <Box
              sx={{
                transform: "translate(-10%, -60%)",
                position: "absolute",
                zIndex: 1,
                width: "765px",
                height: "460px",
                mixBlendMode: "multiply",
              }}
            >
              <img src={ellipse} alt="" />
            </Box>
            <Box
              sx={{
                position: "absolute",
                transform: "translate(0, -85%)",
                height: 372,
                width: "100%",
              }}
            >
              <img src={bgImage} alt="" />
            </Box>
            <Box sx={{ position: "absolute", zIndex: 2 }}>
              <Paper
                sx={{
                  textAlign: "center",
                  padding: 6,
                  borderRadius: "24px",
                }}
              >
                <Typography variant="h3" sx={{ mx: 15 }}>
                  Sign in to access your account.
                </Typography>
                {/* <Box sx={{ mt: 4 }}>
                {!email ? (
                  <MailCheckForm callback={setEmail} />
                ) : (
                  <PasswordCheckForm callback={handleLogin} />
                )}
              </Box> */}

                <Box sx={{ mt: 4 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ bgcolor: "black", color: "white", borderRadius: 50 }}
                    onClick={handleLoginWithAWS}
                  >
                    Sign In
                  </Button>
                </Box>

                <Typography sx={{ mt: 4, color: "red" }}>
                  {errorMessage && <div>{errorMessage}</div>}
                </Typography>
              </Paper>
            </Box>
          </Box>
        </Stack>
      </Stack>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          paddingY: '30px',
          paddingX: '35px'
        }}
      >
        <Logoets />
      </Box>
    </>
  );
};

export default SffLogin;
